import { FilterConfig } from '@/shared/components/table/table.model';
import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';


@Component({
  selector: 'cosmos-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnDestroy {
  public _filterConfig: FilterConfig = {
    propertyName: '',
    filterOptions: [],
  };
  public _filterFieldContentSubject = new Subject<string>();

  private readonly _filterValueSubject = new Subject<string>();
  public selectedFilter$ = this._filterValueSubject.asObservable();

  public ngOnDestroy(): void {
    this._filterValueSubject.complete();
  }

  public onFilterChange(change: string): void {
    this._filterValueSubject.next(change);
    this._filterFieldContentSubject.next(this._filterConfig.propertyName + ': ' + change);
  }

  public setFilterConfig(config: FilterConfig) {
    this._filterConfig = config;
    this._filterFieldContentSubject.next(this._filterConfig.propertyName);
  }
}
